<template>
    <div class="view dashboard">
        <section class="landing">
            <div>
                <create />
            </div>
        </section>
    </div>
</template>

<script>
const Create = () => import("../components/pages/Create");
export default {
    name: 'CreateView',
    components: { Create },
}
</script>
